import { Sinusoid } from "../../core/util/Sinusoid";
import { useContext } from "react";
import { GameIndexContext } from "../../core/util/Context";
import { useUpdate } from "../../core/util/UseUpdate";
const cachedPoolFunctionsByGameIndex = {};
export const POOL_SCALE = 7;
const WAVE_HEIGHT = 0.05;
export function useRunPoolFunction() {
    const gameIndex = useContext(GameIndexContext);
    useUpdate((state, deltaTime) => {
        if (cachedPoolFunctionsByGameIndex[gameIndex] !== undefined) {
            cachedPoolFunctionsByGameIndex[gameIndex].updateAxes(deltaTime);
        }
    }, -5);
}
export function usePoolFunction() {
    const gameIndex = useContext(GameIndexContext);
    if (cachedPoolFunctionsByGameIndex[gameIndex] === undefined) {
        cachedPoolFunctionsByGameIndex[gameIndex] = new Sinusoid({
            numAxes: 7,
            periods: [0.5, 1],
            speed: 3.75,
            axisRandomization: true,
            speedRandomization: true,
        });
    }
    const baseFunction = cachedPoolFunctionsByGameIndex[gameIndex];
    return (x, z) => baseFunction.sample(x, z) * WAVE_HEIGHT * POOL_SCALE;
}
//# sourceMappingURL=UsePoolFunction.js.map